import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";

export const InvoiceOrdersCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const count = props.row.original.poCount;
  return <div>{count}</div>;
};
